(function ($) {

'use strict';

	/**
	 * Puts a parallax effect on the targetted element.
	 * @param array options 
	 */
	$.fn.parallax = function (options) {
		// disable the parallax effect for chrome based browsers, because the perfomance is bad
		if (/chrom(e|ium)/.test(navigator.userAgent.toLowerCase())) {
			return;
		}

		var $_this = $(this);

		var config = $.extend({
			speed: 0.5,
			addOffset: 0,
			backgroundOffset: '50%'
		}, options || {});

		var lastScrollPos = 0;
		$(window).on('scroll', function () {
			var windowYOffset = $(this).scrollTop();
			if (lastScrollPos !== windowYOffset) {
				$_this.css('background-position', config.backgroundOffset + ' ' + Math.round(windowYOffset * config.speed - config.addOffset) + 'px');
				lastScrollPos = windowYOffset;
			}
		});
	};

}(jQuery));